
export const padNumber = (v: number): string => {
	return (String(v).length >= 2) ? `${v}` : `0${v}`;
}
